<template>
  <div>
    <Breadcrumbs title="Reporting"/>

    <div class="container-fluid" v-if="!metricsError">
      <div class="row" v-if="metrics">
        <div class="col-md-4">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body d-flex align-items-end">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="startDate">Start Date</label>
                        <input id="startDate" type="date" v-model="startDate" @change="checkDateValue" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="endDate">End Date</label>
                        <input id="endDate" type="date" v-model="endDate" @change="checkDateValue" class="form-control">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <button class="btn btn-primary" @click="filter()" :disabled="!$v.startDate.required || !$v.endDate.required">
                        <i class="fa fa-filter"></i> &nbsp;Filter
                      </button>
                      <button class="btn btn-primary ml-4" @click="reset()">
                        Reset
                      </button>
                    </div>
                    <div class="col-12" v-if="errorMsg">
                      <div class="alert alert-danger mt-2 p-1">{{errorMsg}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="card card-gradient" :class="{'metricsLoading': metricsLoading}">
                <div class="card-body text-center o-hidden">
                  <div class="knob-header"><h5>Public SMARTracs</h5>
                    <div class="d-inline-block pull-right f-16">#</div>
                  </div>
                  <div class="knob-block text-center knob-center">
                    <div id="total_students" class="knob">
                      <div class="review">
                        {{metrics.publicSmartTracCount}}
                      </div>
                    </div>
                  </div>
                  <img src="../assets/images/university/round.png" alt="" class="round-image"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-12">
              <div class="card" :class="{'metricsLoading': metricsLoading}">
                <div class="card-body">
                  <div class="media feather-main">
                    <div class="feather-icon-block">
                      <i class="fa fa-file"></i>
                    </div>
                    <div class="media-body align-self-center"><h6>Total SMARTracs</h6>
                      <p>{{metrics.smartTracCount}}</p></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="card" :class="{'metricsLoading': metricsLoading}">
                <div class="card-body">
                  <div class="media feather-main">
                    <div class="feather-icon-block">
                      <i class="fa fa-file"></i>
                    </div>
                    <div class="media-body align-self-center"><h6>Total UserTracs</h6>
                      <p>{{metrics.userTracCount}}</p></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="card" :class="{'metricsLoading': metricsLoading}">
                <div class="card-body">
                  <div class="media chart-university">
                    <div class="media-body">
                      <h3 class="mb-0">
                        <span class="counter">% {{metrics.completeUserTracPercentage}}</span></h3>
                      <p>UserTracs Completed</p></div>
                    <div class="small-bar">
                      <div class="ct-small-left flot-chart-container">
                        <Metrics />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-if="metrics.isAdmin">
              <div class="card" :class="{'metricsLoading': metricsLoading}">
                <div class="card-body">
                  <div class="media chart-university">
                    <div class="media-body">
                      <h3 class="mb-0">
                        <span class="counter"># {{metrics.activeEndUserCount}}</span></h3>
                      <p>Total Active End Users</p></div>
                    <div class="small-bar">
                      <div class="ct-small-left flot-chart-container">
                        <Metrics />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4" v-if="metrics && metrics.clientPerCoachCount">
          <div class="card height-equal" v-if="metrics.isAdmin" :class="{'metricsLoading': metricsLoading}">
            <div class="card-header">
              <h5>End Users per Partner/Coach</h5>
            </div>
            <div class="card-body metrics">
              <div class="upcoming-event">
                <div class="upcoming-innner media" v-for="(item, i) in metrics.clientPerCoachCount.slice(0, 5)" :key="i">
                  <div class="bg-primary left m-r-20">
                    {{ item.name.charAt(0) }}
                  </div>
                  <div class="media-body">
                    <h6 class="f-w-600">{{ item.name }}</h6>
                    <p class="mb-0">Client Count: {{item.clientCount}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer btn-more text-center see-more">
              <a href="#" @click.prevent="$bvModal.show('modal-4')">SEE ALL...</a>
            </div>
            <b-modal id="modal-4" hide-footer centered title="End Users per Partner/Coach" class="theme-modal">
              <div class="card height-equal mb-0">
                <div class="card-body p-0">
                  <div class="upcoming-event">
                    <div class="upcoming-innner media" v-for="(item, i) in metrics.clientPerCoachCount" :key="i">
                      <div class="bg-primary left m-r-20">
                        {{ item.name.charAt(0) }}
                      </div>
                      <div class="media-body">
                        <h6 class="f-w-600">{{ item.name }}</h6>
                        <p class="mb-0">Client Count: {{item.clientCount}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {mapGetters} from "vuex";
import Metrics from "../components/metrics";
import moment from "moment"
import {required} from "vuelidate/lib/validators";

function checkDate(start, end) {
  var mStart = moment(start);
  var mEnd = moment(end);
  return mStart.isBefore(mEnd);
}

export default {
  name: "reporting",
  data() {
    return {
      startDate: '',
      endDate: '',
      submitted: false,
      errorMsg: ''
    }
  },
  computed: {
    ...mapGetters([
      'metrics',
      'metricsError',
      'metricsLoading'
    ])
  },
  validations: {
    startDate: { required },
    endDate: { required },
  },
  methods: {
    ...mapActions([
      'getMetrics'
    ]),
    checkDateValue() {
      if (!checkDate(this.startDate, this.endDate) && this.submitted) {
        this.errorMsg = 'The start date should not be greater than End date'
      } else {
        this.errorMsg = ''
      }
    },
    filter() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (!checkDate(this.startDate, this.endDate)) {
        this.errorMsg = 'The start date should not be greater than End date'
        return;
      }
      this.submitted = false;

      this.getMetrics({startDate: this.startDate, endDate: this.endDate});
    },
    reset() {
      this.startDate = '';
      this.endDate = '';
      this.getMetrics(null);
    }
  },
  components: {
    Metrics
  },
  mounted() {
    this.getMetrics();
  }
}
</script>

<style scoped lang="scss">
.feather-main .media-body h6 {
  text-transform: revert !important;
}
.feather-main .media-body p {
  font-size: 18px;
}
.feather-main .feather-icon-block {
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 18px;
    color: #fff;
  }
}
.chart-university .media-body p {
  font-size: 15px !important;
}
.review {
  position: relative;
  height: 180px;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  font-weight: 600;
  color: rgb(255, 255, 255);
  border: 8px solid #fff;
  border-radius: 50%;
}
.card-gradient .knob-header h5 {
  text-transform: revert !important;
}
.upcoming-event .upcoming-innner .left {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}
.upcoming-event .upcoming-innner {
  padding: 13px 0;
}
.card .card-footer.see-more {
  padding: 15px;
}
.card .card-body.metrics {
  padding: 22px;
}
.metricsLoading:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, #ececec, #dedede);
  border-radius: 8px;
  z-index: 9;
}
@media (max-width: 992px) {
  .review {
    border: 0;
  }
}
</style>
